import { LitElement, html, css } from 'lit'

class ArrowLeft extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: var(--icon-width, 1em);
      height: var(--icon-height, auto);
      position: relative;
      top: var(--icon-offset, 2px);
    }
    svg {
      stroke: var(--icon-stroke-color, currentColor);
      stroke-width: var(--icon-stroke-width, 1.5);
      fill: none;
      width: 100%;
      height: auto;
    }
  `
  static properties = {
    open: { type: Boolean },
  }
  render() {
    return html`
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 12H19M5 12L11 6M5 12L11 18"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `
  }
}
customElements.define('arrow-left', ArrowLeft)
